import { Network } from '../util/network';
import type { JamespotUserApi } from './jamespotUserApi';

export class JBaseApi {
    public jApi: JamespotUserApi;
    public network: Network;

    public constructor(jApi: JamespotUserApi) {
        this.jApi = jApi;
        this.network = jApi.network;
    }
}
